var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53842 2.36742C5.69565 1.9232 6.32388 1.9232 6.48111 2.36742L7.39184 4.94044C7.46252 5.14013 7.65136 5.2736 7.86319 5.2736H10.6187C11.0875 5.2736 11.2986 5.86073 10.9371 6.15919L8.94351 7.80497C8.79985 7.92356 8.73403 8.11219 8.77273 8.29442L9.37387 11.125C9.46421 11.5504 9.00594 11.8804 8.63115 11.6598L6.26339 10.2661C6.10686 10.174 5.91267 10.174 5.75614 10.2661L3.38838 11.6598C3.01359 11.8804 2.55532 11.5504 2.64566 11.125L3.2468 8.29442C3.2855 8.11219 3.21969 7.92356 3.07603 7.80497L1.08248 6.15919C0.720962 5.86073 0.932002 5.2736 1.4008 5.2736H4.15635C4.36817 5.2736 4.55701 5.14013 4.62769 4.94044L5.53842 2.36742Z",
    fill: "#00875F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAndroid);
export default __webpack_public_path__ + "static/media/star-android.35d314dffdb1f384e9a77bf264e1d24f.svg";
export { ForwardRef as ReactComponent };